export const SIPConnectedBadgeColor = '#36DD39';
